import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { D2LField } from 'src/app/core/models/d2l-field.model';

@Injectable({ providedIn: 'root' })
export class D2LFieldService {

    constructor(private http: HttpClient) { }

    getD2LFields(): Observable<D2LField[]> {
        return this.http.get<D2LField[]>('api/d2lfield');
    }
}